import { PAYMENTS_SERVICE_URI } from "env";
import { assertOk, proxyFetch } from "../utils";

export { default as useGetTransactionMethods } from "./useGetTransactionMethods";

const paymentsProxy = proxyFetch(PAYMENTS_SERVICE_URI);

export const getTransactionMethods = async (ctx, params) => {
  // params should be a dict object with keys that already match what is expected as a search param key
  let qParams = '';
  if (params &&  Object.keys(params).length > 0) {
    const search = new URLSearchParams(params);
    qParams = `?${search.toString()}`;
  }
  const response = await paymentsProxy(ctx, `/transaction-methods${qParams}`, "GET");
  assertOk(response);
  return response.json();
};
